import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import BodySpecialFetchContainer from '../BodySpecialFetchContainer';
import ISA315ManageITSPListItem from './ISA315ManageITSPListItem';
import CreateEditEntityModal from '../../../../../../Common/EntityCrud/CreateEditEntityModal';
import {itControlApproachType} from '../../../../../../../util/uiconstants';

export default function ISA315ManageITSPList({
	className,
	allIds: itProcessesIds,
	engagementId,
	documentId,
	documentEngagementId,
	bodyId,
	bodyTypeId,
	openRelateModal
}) {
	const [showModal, setShowModal] = useState(false);
	const [entityData, setEntityData] = useState({});

	const onDropdownOptionClick = useCallback((data) => {
		setEntityData(data);
		setShowModal(true);
	}, []);

	return (
		<StyledBodySpecialManageITSP className="StyledBodySpecialManageITSP">
			{showModal && (
				<CreateEditEntityModal
					isITGC={
						!entityData?.itApproachTypeId ? true : entityData?.itApproachTypeId === itControlApproachType.controls
					}
					entityType={entityData?.entityId}
					entityId={entityData?.entityUId}
					itProcessId={entityData?.itProcessId}
					itProcessName={entityData?.itProcessName}
					parentEntityId={entityData?.parentEntityId}
					parentEntityName={entityData?.parentEntityName}
					showCreateEditEntityModal={showModal}
					setShowCreateEditEntityModal={setShowModal}
				/>
			)}
			<BodySpecialFetchContainer className={className}>
				{itProcessesIds.map((itProcessId) => (
					<ISA315ManageITSPListItem
						key={itProcessId}
						engagementId={engagementId}
						bodyId={bodyId}
						itProcessId={itProcessId}
						onDropdownOptionClick={onDropdownOptionClick}
						documentEngagementId={documentEngagementId}
						documentId={documentId}
						openRelateModal={openRelateModal}
					/>
				))}
			</BodySpecialFetchContainer>
		</StyledBodySpecialManageITSP>
	);
}

ISA315ManageITSPList.propTypes = {
	className: PropTypes.string,
	itProcessesIds: PropTypes.arrayOf(PropTypes.number).isRequired,
	engagementId: PropTypes.number.isRequired,
	bodyId: PropTypes.number.isRequired
};

ISA315ManageITSPList.defaultProps = {
	className: 'isa315-itprocess-itrisk-list customScrollbar',
	itProcessesIds: [],
	engagementId: 0,
	bodyId: 0
};

const StyledBodySpecialManageITSP = styled.section`
	.isa315-itprocess-itrisk-list {
		min-height: inherit;
		.StyledBodySpecialAccordionHeader {
			.primary-entity__child-entity {
				width: var(--px-200);
				padding-top: var(--px-5);
				font-size: var(--px-12) !important;
				font-weight: 300 !important;
			}
			.body-special-accordion-header-group {
				width: var(--px-410);
				.body-special-accordion-header-group-list {
					.StyledBodySpecialAccordionHeaderColumn {
						padding: 0;
						width: var(--px-100);
						.StyledBodySpecialAccordionHeaderColumnGroup {
							.body-special-accordion-header-column-header {
								font-size: var(--px-10);
								font-weight: 300;
							}
							.body-special-accordion-header-column-value {
								font-size: var(--px-14);
								font-weight: 400;
							}
						}
					}
				}
			}
		}
	}
`;
